module.exports = __webpack_public_path__ + "img/h5_screenshot_express.708b161b.jpg";